export const initial = {
    success: false,
};

export function update(state, payload) {
    return { ...state, ...payload };
}



// WEBPACK FOOTER //
// ./app/reducers/recaptcha.js